// 判断是否旧桌面端打开的页面
export const isDesktopOpen = window.location?.search?.includes('desktopView=1')
